export default "__VITE_ASSET__DfLETmBf__";